import React from 'react';
import { Link } from 'react-router-dom';
import ToolStatusBadge from 'components/admin/search/ToolStatusBadge';
import Tooltip from 'components/controls/Tooltip';
import styled from 'styled-components';
import { ToolHeadState } from 'types/tools/ToolHeadState';
import { EpdLinks } from 'routes/EpdRoutes';
import { useToolsListForOwner } from 'services/api/companyOwnedToolsQueries';

interface Props {
  companyId: string;
}

const CompanyOwnedToolsList: React.FC<Props> = ({ companyId }) => {
  const tools = useToolsListForOwner(companyId).data;
  if (!tools) {
    return null;
  }

  return (
    <div>
      <h3>Your tools</h3>

      <ToolsList>
        {tools.map((t) => (
          <ToolContainer key={t.id}>
            <ToolLink to={EpdLinks.manageCompanyTool(companyId, t.id)}>{t.name || '<Unnamed tool>'}</ToolLink>
            <div>
              <ToolStatusBadge toolHeadState={t.headState} />
              {t.headState === ToolHeadState.INACTIVE && t.inactiveMessage && (
                <Tooltip position="title">The tool was disabled due to {t.inactiveMessage}</Tooltip>
              )}
            </div>
          </ToolContainer>
        ))}
      </ToolsList>
    </div>
  );
};

export default CompanyOwnedToolsList;

const ToolsList = styled.div`
  margin-top: 32px;
  max-width: 624px;
  display: grid;
  gap: 19px;
`;

const ToolContainer = styled.div`
  display: flex;
`;

const ToolLink = styled(Link)`
  flex-grow: 1;
  flex-shrink: 1;
  font-size: 16px;
  color: ${(props) => props.theme.colors.primaryBlack};
  text-decoration: none;

  &:hover {
    color: ${(props) => props.theme.colors.primaryGreen};
  }
`;
